"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrecisionCost = exports.COIN_PRECISION_MAP = exports.safeFormatNumToStr = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
function safeFormatNumToStr(n, defaultStr) {
    if (n === undefined || n === null || n === "") {
        return defaultStr || undefined;
    }
    return new trade_utils_lib_1.SafeDecimal(n).toFixed();
}
exports.safeFormatNumToStr = safeFormatNumToStr;
/**币对对应的精度定位 */
exports.COIN_PRECISION_MAP = {
    USDT: 2,
};
const getPrecisionCost = (quote, precisionCost) => {
    const p = exports.COIN_PRECISION_MAP[quote];
    return p !== null && p !== void 0 ? p : precisionCost;
};
exports.getPrecisionCost = getPrecisionCost;
